import Tables from "../components/tables";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useFilters, usePagination, useTable } from "react-table";
import { getDefaultParams } from "../../../../services/DefaultParamets";
import "../../table/FilteringTable/filtering.css";
import { CurrencyComponent } from "../components/CurrencyComponnet";
import DatePickerSingle from "../components/DatePickerSingle";

import Comentarios from "jsx/components/CitoPlus/components/sidebar_comments";
import { ButtonGroup } from "react-bootstrap";
import { BotonDangerText, BotonPrimaryText } from "../components/BotonesCustom";
import {
  CitoPlusLinkIconPrimary,
  LinkPrimary,
} from "../components/CitoPlusLink";
import { notifyError, notifySuccess } from "../components/CitoPlusToastr";
import { formatDate } from "../utils";
import FacturaParking from "./FacturaPark";

import { SpinnerCitoPlus } from "jsx/components/CitoPlus/components/loadingLogo";
import ModalCambiarTextoFactura from "./ModalCambiarTextoFactura";
import FacturacionService from "../../../../services/FacturacionService";

export const FacturacionVehicular = () => {
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");

  const [nextUrl, setNextUrl] = useState(null);
  const [previousUrl, setPreviousUrl] = useState(null);

  // Totales del recuado
  const [sumaTotalRecaudo, setSumaTotalRecaudo] = useState(0);
  const [sumaTotalGraciaRecaudo, setSumaTotalGraciaRecaudo] = useState(0);

  // Dates and filters del recaudo
  const [startDateStart, setDateRangeStart] = useState(null);
  const [startDateEnd, setDateRangeEnd] = useState(null);

  // Modal Facturacion
  const [showModalFacturacion, setShowModalFacturacion] = useState(false);
  const [showModalReciboUrl, setShowModalReciboUrl] = useState(null);
  const [showModalReciboData, setShowModalReciboData] = useState({});

  const [defaultParams] = useState(getDefaultParams());
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterParams, setFilterParams] = useState({
    search: "",
    h_ingreso: "",
    h_salida: "",
  });

  const columns = useMemo(
    () => [
      {
        id: "consecutivo",
        Header: "# ",
        disableFilters: true,
        disableSortable: false,
        accessor: "consecutivo",
      },
      {
        id: "h_ingreso",
        Header: "Ingreso ",
        disableFilters: true,
        disableSortable: false,
        accessor: "h_ingreso",
      },
      {
        id: "h_salida",
        Header: "Salida ",
        disableFilters: true,
        disableSortable: false,
        accessor: "h_salida",
      },
      {
        Header: "Unidad ",
        disableFilters: true,
        disableSortable: false,
        accessor: (row) => {
          return (
            <>
              {row.es_pre_registrado && (
                <i
                  className="fas fa-user-check me-2 text-primary"
                  title="Pre-registrado"
                ></i>
              )}
              {row.unidad_visita}
            </>
          );
        },
      },
      {
        Header: "Vehículo ",
        disableFilters: true,
        disableSortable: true,
        accessor: (row) => _.get(row, "vehiculo", "").toUpperCase(),
      },
      {
        Header: "Valor ",
        disableFilters: true,
        disableSortable: false,
        accessor: (row) => {
          return (
            <>
              <div className="right-align-cell">
                <p className="paragraph-left">Gracia: {row.total_gracia}</p>
                <p className="paragraph-left">
                  Total: {row.total.toLocaleString("es-ES")}
                </p>
              </div>
            </>
          );
        },
      },
      {
        Header: "Acciones",
        disableFilters: true,
        disableSortable: true,
        accessor: (row) => {
          return (
            <div className="form-group">
              <ButtonGroup aria-label="Botones de acciones">
                <CitoPlusLinkIconPrimary
                  title="Ver facturación"
                  to={`/facturacion-vehicular/${row.slug}/`}
                >
                  <i className="fas fa-eye"></i>
                </CitoPlusLinkIconPrimary>
                <CitoPlusLinkIconPrimary
                  title="Imprimir"
                  onClick={() => {
                    setShowModalReciboUrl(
                      `/api/v3/parking/recaudo/${row.slug}/detalle_factura_en_progreso/`,
                    );
                    setShowModalFacturacion(true);
                  }}
                >
                  <i className="fas fa-print"></i>
                </CitoPlusLinkIconPrimary>
                <CitoPlusLinkIconPrimary
                  href="#"
                  onClick={() => {
                    handleComentariosClick(row.slug);
                  }}
                >
                  <i className="fas fa-comments"></i>
                  {row.total_comentarios > 0 && (
                    <span
                      className="badge bg-light rounded-circle position-absolute top-0 start-100 translate-middle"
                      style={{ zIndex: 1, color: "black", fontSize: "12px" }}
                    >
                      {row.total_comentarios}
                    </span>
                  )}
                </CitoPlusLinkIconPrimary>
              </ButtonGroup>
            </div>
          );
        },
      },
    ],
    [],
  );

  const fetchTotales = async () => {
    try {
      const response = await FacturacionService.getTotales(filterParams);
      setSumaTotalRecaudo(response.data.total);
      setSumaTotalGraciaRecaudo(response.data.total_tiempo_gracia);
      setTotalRecords(response.data.total_registros);
    } catch (error) {
      console.error("Error fetching totals:", error);
    }
  };

  const fetchUrl = async (args = {}) => {
    let params = typeof args === "number" ? { pageIndex: args } : args;

    const {
      pageIndex = 1,
      search = searchValue,
      ordering = `${order === "desc" ? "-" : ""}${sortField}`,
      url = "",
    } = params;

    setLoading(true);
    try {
      const response = url
        ? await FacturacionService.getRecaudoPorUrl(url)
        : await FacturacionService.getRecaudo({
            ...defaultParams,
            ...filterParams,
            page: pageIndex,
            ordering: ordering,
            search: search,
          });

      setData(response.data.results);
      setNextUrl(response.data.next);
      setPreviousUrl(response.data.previous);
      setTotalPages(response.data.total_pages);
      setCurrentPage(response.data.current_page);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTotales();
    fetchUrl(1);
  }, []);

  useEffect(() => {
    if (filterApplied) {
      fetchTotales();
      fetchUrl(1);
      setFilterApplied(false);
    }
  }, [filterApplied]);

  const handleSearchChange = () => {
    setFilterApplied(true);
  };

  const handleSortingChange = (column) => {
    const { id } = column;
    const newOrder =
      sortField === id ? (order === "asc" ? "desc" : "asc") : "asc";
    setSortField(id);
    setOrder(newOrder);
    fetchUrl({
      pageIndex: 1,
      ordering: `${newOrder === "desc" ? "-" : ""}${id}`,
    });
  };

  const handleExport = async () => {
    try {
      const response = await FacturacionService.exportRecaudo(filterParams);
      if (response.status === 200) {
        notifySuccess(
          "El archivo será enviado al correo registrado. Este proceso puede tardar hasta 10 minutos.",
        );
      }
    } catch (error) {
      notifyError("Error al iniciar proceso de exportación.");
    }
  };

  // Minuta Cambiar Text Factura
  const [showModalCambiarTextoFactrura, setShowModalCambiarTextoFactrura] =
    useState(false);
  const handleShowCambiarTextoFactrura = () =>
    setShowModalCambiarTextoFactrura(true);
  const handleCloseCambiarTextoFactrura = () =>
    setShowModalCambiarTextoFactrura(false);

  const tableInstance = useTable(
    {
      columns,
      data,
      manualPagination: true,
      pageCount: totalPages,
    },
    useFilters,
    usePagination,
  );

  // Comentarios
  const [showSidebarComments, setShowSidebarComments] = useState(false);
  const [urlComentariosParams, setUrlComentariosParams] = useState({});
  const [selectedPrePostData, setSelectedPrePostData] = useState({});

  const handleComentariosClick = (slug) => {
    setSelectedPrePostData({ visitante: slug, nota: "" });
    setUrlComentariosParams({ visitante__slug: slug, page_size: 100 });
    setShowSidebarComments(true);
  };

  const handleNewComment = () => fetchUrl(currentPage);

  const { prepareRow, page } = tableInstance;

  return (
    <>
      <div className="d-flex aling-items-center mb-4 flex-wrap">
        <h4 className="fs-20 mb-0 me-auto">Recaudo vehicular</h4>
        <LinkPrimary to={"#"} onClick={handleShowCambiarTextoFactrura}>
          <i className="fas fa-file-excel me-2"></i>Cambiar texto factura
        </LinkPrimary>
      </div>

      <div className="col-xl-12 col-lg-12 col-sm-12">
        <div className="card">
          <div className="card-headers pt-0 pb-0 text-center">
            <div className="row">
              <div className="col-4 pt-3 pb-3 border-end">
                <h3 className="mb-1 text-primary">{sumaTotalGraciaRecaudo}</h3>
                <span>Total Tiempo Gracia</span>
              </div>
              <div className="col-4 pt-3 pb-3 border-end">
                <h3 className="mb-1 text-primary">
                  <CurrencyComponent amount={sumaTotalRecaudo} />
                </h3>
                <span>Total Recaudo</span>
              </div>
              <div className="col-4 pt-3 pb-3">
                <h3 className="mb-1 text-primary">{totalRecords}</h3>
                <span>Total Registros</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <div className="card-tools w-100">
            <div className="row align-items-center">
              <div className="input-group input-group-sm row">
                <div className="col-md-3 col-sm-12 p-0 row align-items-center">
                  <div className="px-2">
                    <input
                      type="text"
                      value={filterParams.search}
                      className="form-control form-control-sm rounded w-full h-50"
                      placeholder="Buscar por consecutivo, inmueble, placa..."
                      onChange={(e) => {
                        setFilterParams({
                          ...filterParams,
                          search: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-3 col-sm-12 p-0 row align-items-center">
                  <DatePickerSingle
                    selectedDate={startDateStart}
                    placeholderText="Fecha de Ingreso"
                    onChange={(date) => {
                      setDateRangeStart(date);
                      setFilterParams({
                        ...filterParams,
                        h_ingreso: date ? formatDate(date) : "",
                      });
                    }}
                  />
                </div>
                <div className="col-md-3 col-sm-12 p-0 row align-items-center">
                  <DatePickerSingle
                    selectedDate={startDateEnd}
                    placeholderText="Fecha de Salida"
                    onChange={(date) => {
                      setDateRangeEnd(date);
                      setFilterParams({
                        ...filterParams,
                        h_salida: date ? formatDate(date) : "",
                      });
                    }}
                  />
                </div>
                <div className="col-md-3 col-sm-12 p-0 row align-items-center">
                  <ButtonGroup className="align-items-right position-relative">
                    <BotonPrimaryText
                      title="Buscar"
                      onClick={handleSearchChange}
                    >
                      <i className="fa fa-search me-1"></i>Filtrar
                    </BotonPrimaryText>
                    <BotonDangerText
                      title="Limpiar"
                      onClick={() => {
                        setDateRangeStart(null);
                        setDateRangeEnd(null);
                        setFilterParams({
                          search: "",
                          h_ingreso: "",
                          h_salida: "",
                        });
                        setFilterApplied(true);
                      }}
                    >
                      <i className="fa fa-times me-1"></i>Limpiar
                    </BotonDangerText>
                    <BotonPrimaryText title="Exportar" onClick={handleExport}>
                      <i className="fa fa-download me-1"></i>Exportar
                    </BotonPrimaryText>
                  </ButtonGroup>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <SpinnerCitoPlus text="Cargando datos..." />
          ) : data.length === 0 ? (
            <p>No hay datos disponibles.</p>
          ) : (
            <Tables
              columns={columns}
              data={data}
              loading={loading}
              totalPages={totalPages}
              currentPage={currentPage}
              totalRecords={totalRecords}
              nextUrl={nextUrl}
              previousUrl={previousUrl}
              fetchUrl={fetchUrl}
              handleSortingChange={handleSortingChange}
              sortField={sortField}
              order={order}
              page={page}
            />
          )}
        </div>
      </div>

      <FacturaParking
        isOpen={showModalFacturacion}
        onClose={() => setShowModalFacturacion(false)}
        URL={showModalReciboUrl}
        dataFromPatch={showModalReciboData}
      />

      <ModalCambiarTextoFactura
        showModal={showModalCambiarTextoFactrura}
        onClose={handleCloseCambiarTextoFactrura}
      />

      <Comentarios
        showSidebarComments={showSidebarComments}
        setShowSidebarComments={setShowSidebarComments}
        urlComentarios="/api/v3/vigilancia/visitantes-comentarios/"
        urlComentariosParams={urlComentariosParams}
        urlPost="/api/v3/vigilancia/visitantes-comentarios/"
        selectedPrePostData={selectedPrePostData}
        handleNewComment={handleNewComment}
      />
    </>
  );
};

export default FacturacionVehicular;
